import * as React from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import Divider from '@mui/joy/Divider';
import Typography from '@mui/joy/Typography';
import FundiBidCard from '../../card/fundi/FundiBidCard';
import { Stack } from '@mui/joy';
import Reviews from '../../Reviews'


const FundiActiveJobs = () => {
  return (
    <Card variant='outlined' sx={{ maxWidth: '100%', margin: '30px auto',backgroundColor:'transparent' }}>
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4, padding: 2 }}

      >

        <Button
          sx={{
            padding: '5px 30px 5px', maxWidth: '220px', textAlign: 'center',
            backgroundColor: '#94b0d1',color: '#354e6e',
            '&:hover': {
              backgroundColor: '#94b0d1',
              color: '#354e6e', boxShadow: 3,
            },

          }}>Job Id- 247TU4FU29</Button>
        <Button
          sx={{
            padding: '5px 30px 5px', maxWidth: '100%', textAlign: 'center',
            backgroundColor: '#28A745',
            '&:hover': {
              backgroundColor: '#28A745',
              color: '#ffffff', boxShadow: 3,
            },

          }}>Payment Done</Button>
      </Box>
      <Divider inset='none' sx={{ height: '2px', backgroundColor: '#000' }} />
      <Stack
        direction='row'
        sx={{ justifyContent: 'space-between', alignItems: 'left', padding: 2 }}
      >
        <Box>
          <Typography gutterBottom variant='h5' component='div'>
            Job -
          </Typography>
          <Typography level='body-xs' sx={{ textAlign: 'center' }}>Plumbing (Leak Fixing) </Typography>

        </Box>
        <Box>
          <Typography gutterBottom variant='h5' component='div'>
            Date & Time -
          </Typography>
          <Typography level='body-xs' sx={{ textAlign: 'left' }}>  12/01/2025 & Evening 2 to 7</Typography>

        </Box>
        <Box>

          <Typography level='body-xs' sx={{ textAlign: 'left', fontSize: '18px'}}> Payment  -  <span style={{ fontSize: '24px', color: '#000', fontWeight: 600,marginLeft:'15px'}}>€ 120</span> </Typography>

        </Box>
      </Stack>
      <Divider inset='none' sx={{ height: '2px', backgroundColor: '#000' }} />
   

      <Box
        display='flex'
        gap={2} 
      
      >
        <Box
        sx={{m:0,p:0}}
        >
          <Box sx={{ width:'300px', height:'80px',m:0,p:1,display: 'flex', justifyContent:'flex-start', alignItems:'center',gap:3 }}>
            <FundiBidCard/>
            <Box>
              <Typography  variant='h5' sx={{fontSize:'20px',fontWeight:500}}>
                Kalvin
              </Typography>
              <Typography level='body-xs' sx={{ textAlign: 'left' }}>  City Name, country Name</Typography>

            </Box>
          </Box>
        </Box>
        <Box
    
          sx={{m:0,p:1}}
        >
          <Box
            display='flex'
            justifyContent='space-between'
           

          >
            <Typography variant='h4' sx={{fontSize:'20px',fontWeight:500}}>
           Reviews
           </Typography>
            <Box       
              textAlign='center'
            >
              <Reviews/>
            </Box>
          </Box>
           <Typography variant='body1' sx={{textAlign:'justify'}}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero quisquam sed adipisci perspiciatis reprehenderit velit vel nobis maxime, earum beatae accusantium excepturi expedita alias ut in illo inventore dolores vero quae quia, laborum iste ea. Harum quasi modi delectus necessitatibus!</Typography>
        </Box>
      </Box>


    </Card>
  );
}


export default FundiActiveJobs;